<app-loading-spinner [active]="loadingContent"></app-loading-spinner>

<form [formGroup]="form">
    <!-- <div class="row">
        <div class="col-12 col-lg-8">
            <app-select label="Fundo de interesse" [group]="form"
                controlName="interest_fund" [items]="fundOptions">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div> -->

    <div class="row">
        <div class="col-12 col-lg-4">
            <app-masked-input [group]="form" controlName="cnpj" label="CNPJ"
                placeholder="00.000.000/0000-00" mask="00.000.000/0000-00"
                [readOnly]="!!invitedInfo.document || !!form.controls.cnpj.value || !!data">
            </app-masked-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-8">
            <app-input [group]="form" controlName="name" label="Razão Social"
                [isUpperCase]="true" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <ng-container *ngIf="userRole === 'provider'">
            <div class="col-12 col-lg-4">
                <app-select [items]="agentOptions" [group]="form"
                    controlName="agent" [multiple]="true" label="Papel">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </ng-container>

        <div class="col-12 col-lg-4">
            <app-input label="Nome fantasia" [group]="form"
                controlName="brand_name">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-masked-input [group]="form" controlName="foundation_date"
                mask="00/00/0000" label="Data da fundação"
                placeholder="dd/mm/aaaa">
            </app-masked-input>

            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-6">
            <app-select [items]="signupService.choices().frameworks"
                [group]="form" controlName="framework"
                label="Natureza jurídica">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-select [items]="signupService.choices().branch_choices"
                [group]="form" controlName="branch"
                label="Forma de constituição">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12">
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row" *ngIf="!isFund">
        <div class="col-12 col-lg-4">
            <app-input [group]="form" controlName="municipal_registration"
                [maxLength]="20" label="Inscrição Municipal"
                placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-input [group]="form" controlName="state_registration"
                label="Inscrição Estadual" placeholder="Digite" [maxLength]="9"
                [readOnly]="form.controls.free_state_registration.value">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-spacer [bottom]="36"></app-spacer>
            <app-radio [multiple]="true"
                formControlName="free_state_registration">
                Isento de inscrição estatual
            </app-radio>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-6" *ngIf="!isFund">
            <app-input [group]="form" controlName="nire" label="NIRE"
                [maxLength]="20" placeholder="Digite"
                helpText="Número de Identificação do Registro Empresarial">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <ng-container *ngIf="isFund">
            <div class="col-12 col-lg-6">
                <app-input [group]="form" controlName="giin" label="GIIN"
                    [maxLength]="25" placeholder="Digite"
                    helpText="Global Intermediary Identification Number">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </ng-container>

        <div class="col-12 col-lg-6">
            <app-select [group]="form" controlName="contract_type"
                [items]="contractTypeItems" label="Tipo de contrato">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12">
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-2">
            <app-select [group]="form" controlName="cellphone_ddi"
                [items]="DDIOptions" label="DDI">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-masked-input [group]="form" controlName="cellphone_number"
                [label]="isFund ? 'Celular contato do Fundo' : 'Celular'"
                mask="(00) 00000-0000||(00) 0000-0000" placeholder="Digite">
            </app-masked-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-2">
            <app-select [group]="form" controlName="telephone_ddi"
                [items]="DDIOptions" label="DDI">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-masked-input [group]="form" controlName="telephone_number"
                [label]="isFund ? 'Telefone contato do Fundo' : 'Telefone'"
                mask="(00) 00000-0000||(00) 0000-0000" placeholder="Digite">
            </app-masked-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-6" *ngIf="!isFund">
            <app-input [group]="form" type="email" controlName="contact_email"
                label="E-mail" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12 col-lg-6" *ngIf="!isFund">
            <app-input [group]="form" type="url" controlName="site" label="Site"
                placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <app-select [items]="signupService.choices().cnaes" [group]="form"
                controlName="cnae" label="CNAE Principal">
            </app-select>
            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <ng-container *ngIf="!isFund">
        <div class="row">
            <ng-container *ngIf="userRole !== 'provider'">
                <div class="col-12 col-lg-6">
                    <app-currency-input [group]="form"
                        controlName="yearly_income" label="Faturamento
      nos últimos 12 meses">
                    </app-currency-input>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12 col-lg-6">
                    <app-currency-input [group]="form" controlName="capital"
                        label="Capital Social">
                    </app-currency-input>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>

            <div class="col-12 col-lg-6">
                <app-select
                    [items]="signupService.choices().company_size_choice"
                    [group]="form" controlName="company_size" label="Porte">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-6">
                <app-select [items]="employeesOptions" [group]="form"
                    controlName="number_employees"
                    label="Número de funcionários">
                </app-select>

                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="userRole === 'provider'">
        <app-spacer [bottom]="48"></app-spacer>
    </ng-container>


    <div class="row" *ngIf="isFund">
        <div class="col-12">
            <div class="info-message" *ngIf="emailArr.length === 0">
                <svg-icon src="assets/images/icon-info.svg"></svg-icon>
                <span>É necessário adicionar ao menos 1 e-mail de contato do
                    fundo</span>
            </div>
            <app-spacer [bottom]="24"
                *ngIf="emailArr.length === 0"></app-spacer>

            <div class="d-flex align-items-center">
                <div class="mr-3">
                    <app-input [group]="form" type="email"
                        controlName="secondary_email"
                        label="E-mail de contato do Fundo" placeholder="Digite">
                    </app-input>
                </div>

                <div>
                    <app-spacer [top]="16"></app-spacer>
                    <app-radio [multiple]="true"
                        formControlName="primary_contact"
                        *ngIf="emailArr.length > 0">
                        Definir como e-mail principal
                    </app-radio>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12">
            <app-button (onClick)="addEmail()" class="add-button"
                [disabled]="!form.controls.secondary_email.valid || !form.controls.secondary_email.value"
                [outline]="true">
                <svg-icon src="assets/images/icon-add.svg"
                    class="mr-2"></svg-icon>
                Adicionar e-mail
            </app-button>

            <app-spacer [bottom]="24"></app-spacer>
        </div>
    </div>

    <div class="row" *ngIf="emailArr.length > 0 && isFund">
        <div class="col-12">
            <app-table [columns]="columns" [data]="emailArr"
                (onRemove)="removeEmail($event)"></app-table>
            <app-spacer [bottom]="32"></app-spacer>
        </div>
    </div>

    <ng-container *ngIf="isFund && userRole === 'shareholder'">
        <div class="row">
            <div class="col-12">
                <app-radio [multiple]="true" formControlName="exclusive_fund">
                    Trata-se de um fundo exclusivo?
                </app-radio>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <ng-container *ngIf="form.controls.exclusive_fund.value">
                <div class="col-12">
                    <span>Informe o nome e documento dos beneficiários finais
                        (pode adicionar mais de um)</span>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12"
                    *ngIf="exclusiveFundBeneficiaries.length === 0">
                    <div class="info-message">
                        <svg-icon src="assets/images/icon-info.svg"></svg-icon>
                        <span>É necessário adicionar ao menos 1 beneficiário
                            final.</span>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <ng-container *ngIf="exclusiveFundBeneficiaries.length > 0">
                    <div class="col-12">
                        <app-table [columns]="beneficiaryColumns"
                            [data]="exclusiveFundBeneficiaries"
                            (onRemove)="removeBeneficiary($event)"></app-table>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </ng-container>

                <div class="col-12"
                    *ngIf="exclusiveFundBeneficiaries.length > 0 && !showBeneficiaryForm">
                    <app-button (onClick)="openBeneficiaryForm()"
                        class="add-button" [outline]="true">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2"></svg-icon>
                        Adicionar outro beneficiário
                    </app-button>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <ng-container *ngIf="showBeneficiaryForm">
                    <div class="col-11 offset-1">
                        <app-radio [multiple]="true"
                            formControlName="beneficiary_estrangeiro">
                            Estrangeiro
                        </app-radio>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-11 offset-1">
                        <app-radio [multiple]="true"
                            formControlName="beneficiary_is_pep">
                            Pessoa Exposta Politicamente (PEP?)
                        </app-radio>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-6 offset-1">
                        <app-input [group]="form" controlName="beneficiary_name"
                            label="Nome/Razão Social" placeholder="Digite">
                        </app-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-6 offset-1">
                        <app-input
                            *ngIf="form.controls.beneficiary_estrangeiro.value"
                            [group]="form" controlName="beneficiary_document"
                            label="Documento" placeholder="Digite">
                        </app-input>
                        <app-masked-input
                            *ngIf="!form.controls.beneficiary_estrangeiro.value"
                            [group]="form" controlName="beneficiary_document"
                            label="CPF/CNPJ"
                            placeholder="000.000.000-00 ou 00.000.000/0000-00"
                            mask="CPF_CNPJ">
                        </app-masked-input>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12 d-flex align-items-center">
                        <app-button
                            *ngIf="exclusiveFundBeneficiaries.length > 0"
                            (onClick)="cancelBeneficiaryForm()"
                            class="add-button mr-3" [outline]="true">
                            Cancelar
                        </app-button>

                        <app-button (onClick)="addBeneficiary()"
                            class="add-button" [outline]="true"
                            [disabled]="!form.controls.beneficiary_name.valid || !form.controls.beneficiary_document.valid">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            Adicionar beneficiário
                        </app-button>
                    </div>

                    <div class="col-12">
                        <app-spacer [bottom]="32"></app-spacer>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="userRole !== 'provider'">
        <div class="row">
            <!-- <div class="col-12">
                <app-radio [multiple]="true" formControlName="joint_obligation"
                    [disabled]="form.controls.judicial_recovery.value">
                    Cessão com coobrigação
                </app-radio>
                <app-spacer [bottom]="24"></app-spacer>
            </div> -->

            <ng-container *ngIf="userRole === 'assignor'">
                <div class="col-12">
                    <app-radio [multiple]="true"
                        formControlName="billet_emitter">
                        Emite boleto
                    </app-radio>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12">
                    <app-radio [multiple]="true" formControlName="nfe_emitter">
                        Emite NFe
                    </app-radio>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12">
                    <app-radio [multiple]="true"
                        formControlName="duplicate_emitter">
                        Emite duplicata
                    </app-radio>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>

            <ng-container *ngIf="userRole === 'assignor'">
                <div class="col-12">
                    <app-radio [multiple]="true"
                        formControlName="judicial_recovery">
                        Está em recuperação judicial
                    </app-radio>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12 col-lg-5 offset-lg-1"
                    *ngIf="form.controls.judicial_recovery.value">
                    <app-radio [multiple]="true"
                        formControlName="have_judicial_recovery">
                        Há plano de recuperação judicial
                    </app-radio>
                    <app-spacer [bottom]="24"></app-spacer>

                    <app-masked-input [group]="form"
                        controlName="judicial_recovery_date" mask="00/00/0000"
                        label="Data de aprovação do plano homologado"
                        placeholder="dd/mm/aaaa">
                    </app-masked-input>

                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>

            <ng-container *ngIf="userRole === 'assignor'">
                <div class="col-12">
                    <app-radio [multiple]="true" formControlName="sfn">
                        Faz parte do SFN (Sistema Financeiro Nacional)
                    </app-radio>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>

            <div class="col-12">
                <app-radio [multiple]="true"
                    formControlName="authorization_bacen_queries">
                    Autorizo a {{'brand.name' | theme}}
                    a realizar consultas sobre meus dados no BACEN
                    <span
                        *ngIf="form.controls.authorization_bacen_queries.errors"
                        class="required-field">*</span>
                </app-radio>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>
    </ng-container>


</form>